import { parsePhoneNumberFromString } from "libphonenumber-js";
function asCountryCode(iso) {
    if (!iso || iso.trim().length !== 2) {
        return undefined;
    }
    return iso.trim().toUpperCase();
}
/**
 * Canonical Contact phone normalization.
 * Explicit international input (`+…`) wins over defaultCountryIso.
 */
export function normalizeContactPhoneE164(input) {
    const trimmed = input.raw.trim();
    if (trimmed.length === 0) {
        return { ok: false, reason: "missing" };
    }
    if (trimmed.startsWith("+")) {
        const parsed = parsePhoneNumberFromString(trimmed);
        if (!parsed?.isValid()) {
            return { ok: false, reason: "invalid" };
        }
        return {
            ok: true,
            e164: parsed.format("E.164"),
            countryIso: parsed.country ?? "",
        };
    }
    const country = asCountryCode(input.defaultCountryIso);
    if (!country) {
        return { ok: false, reason: "missing_country" };
    }
    const parsed = parsePhoneNumberFromString(trimmed, country);
    if (!parsed?.isValid()) {
        return { ok: false, reason: "invalid" };
    }
    return {
        ok: true,
        e164: parsed.format("E.164"),
        countryIso: parsed.country ?? country,
    };
}
/** Convenience wrapper returning E.164 string or null (legacy call sites). */
export function normalizeContactPhoneToE164(raw, defaultCountryIso) {
    if (raw == null) {
        return null;
    }
    const result = normalizeContactPhoneE164({ raw, defaultCountryIso });
    return result.ok ? result.e164 : null;
}
/** Detect ISO country from an international phone string for UI sync. */
export function detectCountryIsoFromE164(e164) {
    const parsed = parsePhoneNumberFromString(e164);
    return parsed?.country ?? null;
}
//# sourceMappingURL=contact-phone-e164.js.map